import {GuardSelector} from '@core/store/token/token.selectors';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {environment} from "@env/environment";
import {take} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {ErrorService} from "@services/error.service";
import {NotificationService} from "@services/notification.service";
import {AuthLoginAction, UserPasswordUpdatedAction} from "@modules/users/store/user.actions";
import {LOGSEVERITY, LOGTYPE} from "@core/app.costants";
import {AuthenticationService} from '@core/services/authentication.service';
import {ErrorMapping} from '@core/constants';
import {ApiResponse, ServicesResponse} from "@core/model/servicesResponse";

@Injectable({
  providedIn: 'root'
})
export class EditPasswordService {
  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
    private notificationService: NotificationService,
    private auth:AuthenticationService
  ) { }

  updatePassword(request): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${environment.DASHBOARD_PRIVATE_BASE_URL}/modificaPassword`, request);
  }

  updatePasswordWeb(request): Observable<ServicesResponse> {
    return this.http.post<ServicesResponse>(`${environment.DASHBOARD_PRIVATE_BASE_URL}/aggiornaPwdWeb`, request);
  }

  checkPasswordErrors(errorCode, store, watchdog, router, url, user?) {
    switch (errorCode){
      case '0055': {
        const errorMessage = ErrorMapping.PASSWORD_EXPIRED;
        this.errorService.setError(errorMessage);
        break;
      }
      case '0050': {
        const errorMessage = ErrorMapping.PASSWORD_LAST_FIVE;
        this.errorService.setError(errorMessage);
        break;
      }
      case '401': {
        const errorMessage = ErrorMapping.PASSWORD_INVALID;
        this.errorService.setError(errorMessage);
        break;
      }
      default: {
        this.notificationService.setNotification(`La password è stata correttamente aggiornata`);

        store.dispatch(UserPasswordUpdatedAction());

        watchdog.writeWatchdog({
          type: LOGTYPE.INFO,
          severity: LOGSEVERITY.NONE,
          message: `La password è stata correttamente aggiornata`,
        });

        store.select(GuardSelector).pipe(take(1)).subscribe((token)=>{
          if (token) {
            router.navigate([url]);
          } else{
            this.auth.login(user.email,user.new_password).subscribe((res)=>{
              this.auth.checkUser(res.data.username).subscribe({
                next: user => {
                  store.dispatch(AuthLoginAction({ user }));
                  watchdog.writeWatchdog({
                    type: LOGTYPE.INFO,
                    severity: LOGSEVERITY.NONE,
                    message: "L'utente ha effettuato il login",
                  });
                  router.navigateByUrl('/private-area');
                }
              })
            })
          }
        })
      }
    }
  }
}
